import type { TranslationSchema } from './en.ts';

export const ro: TranslationSchema = {
  common: {
    loading: 'Se încarcă...',
    unknown: 'Necunoscut',
    online: 'Online',
    offline: 'Offline',
    na: 'N/A',
    language: 'Limbă',
    minutesShort: '{{min}}m {{sec}}s',
  },
  app: {
    loadingAuth: 'Se încarcă...',
  },
  login: {
    pageTitle: 'PostureXe Admin',
    pageSubtitle: 'Conectați-vă pentru a accesa platforma',
    username: 'Utilizator',
    password: 'Parolă',
    submit: 'Autentificare',
    submitting: 'Se conectează...',
    successToast: 'Autentificare reușită',
    errorToast: 'Utilizator sau parolă incorectă',
  },
  logo: {
    tagline: 'Analiza Postura',
  },
  layout: {
    systemStatus: 'Status Sistem',
    onlineDevices: 'Dispozitive Online',
    mainMenu: 'Meniu Principal',
    logout: 'Deconectare',
    openMenu: 'Deschide meniul',
    mobileHeaderTitle: 'PostureXe Admin',
  },
  nav: {
    dashboard: 'Dashboard',
    sessions: 'Sesiuni',
    devices: 'Dispozitive',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Statistici generale și monitorizare sistem',
    reportsLoadErrorTitle: 'Eroare la încărcarea rapoartelor',
    totalDevices: 'Total Dispozitive',
    onlineOnlineOffline: '{{online}} online, {{offline}} offline',
    onlineCardTitle: 'Online',
    onlineCardHint: 'Dispozitive conectate',
    offlineCardTitle: 'Offline',
    offlineCardHint: 'Neconectate',
    qrStatsTitle: 'Statistici Acces Coduri QR',
    qrGenerated: 'Coduri QR Generate',
    reportsAccessed: 'Rapoarte Accesate',
    accessRate: 'Rată Acces',
    trendsTitle: 'Tendințe Analiză Postură',
    timePeriod: 'Perioadă Timp:',
    lastDays: 'Ultimele {{count}} zile',
    chartSessions: 'Sesiuni',
    noTrendData: 'Nu există date de tendințe disponibile',
    scoreDistributionTitle: 'Distribuție Sesiuni pe Categorii',
    noDataPeriod: 'Nu există date pentru perioada selectată',
    sessionsByLocation: 'Sesiuni pe Locații',
    barTooltipSessions: '{{count}} sesiuni',
    scoreCategory: {
      excellent: 'Excelent',
      good: 'Bun',
      fair: 'Acceptabil',
      poor: 'Slab',
      very_poor: 'Foarte Slab',
    },
  },
  history: {
    title: 'Sesiuni',
    subtitle: 'Vizualizează și gestionează sesiunile de analiză posturală',
    filters: 'Filtre',
    allLocations: 'Toate Locațiile',
    timePeriod: 'Perioadă Timp:',
    lastDays: 'Ultimele {{count}} zile',
    allSessions: 'Toate sesiunile',
    clearFilters: 'Șterge Filtre',
    loadErrorTitle: 'Eroare la încărcarea sesiunilor',
    loadingSessions: 'Se încarcă sesiunile...',
    emptyFiltered: 'Nicio sesiune nu corespunde filtrelor selectate',
    empty: 'Nu s-au găsit sesiuni',
    entrySingular: '{{count}} intrare',
    entryPlural: '{{count}} intrări',
    pageOf: 'Pagina {{current}} din {{total}}',
    status: {
      completed: 'Finalizată',
      in_progress: 'În curs',
      failed: 'Eșuată',
    },
    loadErrorGeneric: 'Nu s-au putut încărca sesiunile',
  },
  reports: {
    title: 'Lista Dispozitive',
    subtitle: 'Monitorizează și administrează dispozitivele NVIDIA Jetson',
    loadError: 'Nu s-au putut încărca dispozitivele. Încercați din nou.',
    loading: 'Se încarcă dispozitivele...',
    empty: 'Nu există dispozitive',
    statusLabel: 'Status:',
    uptimeLabel: 'Uptime:',
    otaEndpointLabel: 'OTA (public):',
  },
  deviceDetails: {
    loading: 'Se încarcă detaliile dispozitivului...',
    loadErrorTitle: 'Eroare la încărcarea detaliilor dispozitivului',
    backToDevices: 'Înapoi la Dispozitive',
    deviceIdLabel: 'ID Dispozitiv:',
    infoTitle: 'Informații Dispozitiv',
    model: 'Model:',
    uptime: 'Timp Funcționare:',
    currentState: 'Stare Curentă:',
    lastHeartbeat: 'Ultimul Heartbeat:',
    lastSeen: 'Văzut Ultima Dată:',
    locationTitle: 'Locație',
    edit: 'Editează',
    save: 'Salvează',
    saving: 'Se salvează...',
    cancel: 'Anulează',
    name: 'Nume:',
    address: 'Adresă:',
    locationUnsetTitle: 'Locație neconfigurată',
    locationUnsetHint: 'Apasă pe "Editează" pentru a configura locația',
    locationNameLabel: 'Nume Locație',
    locationAddressLabel: 'Adresă Locație',
    locationNamePlaceholder: 'Introduceți numele locației',
    locationAddressPlaceholder: 'Introduceți adresa locației',
    metricsTitle: 'Metrici Curente',
    cpuUsage: 'Utilizare CPU:',
    memoryUsage: 'Utilizare Memorie:',
    performanceTitle: 'Metrici Performanță',
    range1h: '1h',
    range24h: '24h',
    range7d: '7d',
    cpuChartTitle: 'Utilizare CPU',
    memoryChartTitle: 'Utilizare Memorie',
    last20Samples: 'Ultimele 20 măsurători',
    noMetricsData: 'Nu există date de metrici disponibile pentru intervalul de timp selectat',
    updateLocationError: 'Eroare la actualizarea locației',
    fetchError: 'Nu s-au putut încărca detaliile dispozitivului',
  },
  sessionDetails: {
    loading: 'Se încarcă detaliile sesiunii...',
    loadErrorTitle: 'Eroare la încărcarea detaliilor sesiunii',
    backToHistory: 'Înapoi la Istoric',
    title: 'Detalii Sesiune',
    sessionIdLabel: 'ID Sesiune:',
    overallScore: 'Scor General',
    device: 'Dispozitiv:',
    analyses: 'Analize:',
    accuracy: 'Acuratețe:',
    location: 'Locație:',
    postureAnalysis: 'Analiză Postură',
    viewFront: 'Vedere Frontală',
    viewSide: 'Vedere Laterală',
    viewBack: 'Vedere Posterioară',
    shoulderAlignment: 'Aliniere Umeri',
    hipAlignment: 'Aliniere Șolduri',
    neckAngle: 'Unghi Gât',
    spineCurvature: 'Curbură Coloană',
    spineAlignment: 'Aliniere Coloană',
    shoulderBalance: 'Echilibru Umeri',
    legendOptimal: 'Aliniere Optimă',
    legendMinor: 'Deviere Minoră',
    legendNeedsCorrection: 'Necesită Corecție',
    legendFootnote:
      'Zonele colorate indică grupele musculare și alinierea scheletică relevante pentru evaluarea posturii',
    metricOptimal: 'Optim',
    metricModerate: 'Moderat',
    metricNeedsAttention: 'Necesită atenție',
    fetchFailed: 'Nu s-au putut încărca detaliile sesiunii',
  },
  table: {
    score: 'Scor',
    date: 'Dată',
    status: 'Status',
    location: 'Locație',
    device: 'Dispozitiv',
  },
  errors: {
    requestTimeout: 'Timp de așteptare depășit',
    loadReportsData: 'Nu s-au putut încărca datele rapoartelor',
  },
};
